export default {
  getCommunity(context) {
    const productId = context.rootGetters.activeProductId;

    if (!productId) {
      context.commit("setCommunity", null);
      context.commit("setLoaded", true);
      return Promise.resolve(null);
    }

    context.commit("setLoading", true);
    const qs = new URLSearchParams({ product_id: productId }).toString();

    return window.axios
      .get(`/telegram/community?${qs}`)
      .then(({ data }) => {
        context.commit("setCommunity", data);
        return data;
      })
      .catch(() => {
        context.commit("setCommunity", null);
        return null;
      })
      .finally(() => {
        context.commit("setLoading", false);
        context.commit("setLoaded", true);
      });
  }
};
